module.exports = __webpack_public_path__ + "img/종로 피자.cd9d639c.png";